import type { GetOrgMemberReportsItemDto } from 'app/API';
import { formatEditsPerPage } from './formatEditsPerPage';

export const MEMBER_REPORTS_CSV_HEADERS = [
  'ID',
  'Name',
  'Email',
  'Phone',
  'Teams',
  'Active Jobs',
  'Jobs Completed',
  'Edits Per Page',
];

export type TMemberReportCsvSource = Pick<
  GetOrgMemberReportsItemDto,
  'id' | 'name' | 'lastname' | 'email' | 'phone' | 'activeJobs' | 'completedJobs' | 'totalEdits' | 'totalPages'
> & {
  teams?: Array<{ name: string; organizationId: string }> | null;
};

export const buildMemberReportsCsvRows = (members: TMemberReportCsvSource[], organizationId: string) =>
  members.map((member) => ({
    id: member.id,
    name: `${member.name} ${member.lastname}`,
    email: member.email ?? '',
    phone: member.phone ?? '',
    teams: (member.teams ?? [])
      .filter((team) => team.organizationId === organizationId)
      .map((team) => team.name)
      .join(' '),
    activeJobs: member.activeJobs ?? 0,
    completedJobs: member.completedJobs ?? 0,
    editsPerPage: formatEditsPerPage(member.totalEdits, member.totalPages),
  }));
